// extracted by mini-css-extract-plugin
module.exports = {"custom-selection-control":"CustomSelectionControl_custom-selection-control__9OVGw","native-input":"CustomSelectionControl_native-input__DtGBn"};